module.exports = __webpack_public_path__ + "4b6a8ed5c574760dce95c61970003e11.fbx";